<template>
  <div :style="contentStyle" :class="{ 'flex-table': flex }">
    <el-table :data="tableData"
              :ref="tableRef"
              :row-key="rowKey"
              :tree-props="treePorps"
              v-loading="tableLoading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              @select="(selection, row) => $emit('select', selection, row)"
              @selection-change="selection => $emit('selection-change', selection)"
              @select-all="selection => $emit('select-all', selection)"
              @toggle-row-selection="toggleSelection"
              @filter-change="filterChange"
              @sort-change="sortChange"
              @row-click="rowClick"
              @cell-click="(row, column, cell, event) => $emit('cell-click', row, column, cell, event)"
              tooltip-effect="light"
              :size="size"
              :border="border"
              :height="tableHeight"
              :max-height="maxHeight"
              :row-class-name="rowClassName"
              :cell-class-name="cellClassName"
              :cell-style="cellStyle"
              :reserve-selection="reserveSelection"
              :class="{ [classNames]: true, 'header-highlight': headerHighlight }"
              :default-sort="defaultSort"
              :summary-method="summaryMethod"
              :show-summary="showSummary"
              :summary-text="summaryText"
              :span-method="spanMethod"
              class="table-custom"
              header-cell-class-name="table-custom-header-cell">
      <div slot="empty" class="empty">
        <img src="@/assets/empty.svg" />
        <span>暂无数据</span>
      </div>
      <template v-for="config in colConfigs">
        <slot v-if="config.slot"
              :name="config.slot"
              :currentPage="currentPage || pageNum"
              :pageSize="pageSize"></slot>
        <el-table-column v-bind="config"
                         :key="config.prop"
                         :align="config.align ? config.align : 'left'"
                         :header-align="config.headerAlign ? config.headerAlign : 'left'"
                         :column-key="config.prop"
                         :formatter="config.formatter"></el-table-column>
      </template>
    </el-table>
    <pagination-custom :page-size.sync="paginationSize"
                       :current-page.sync="paginationCurrent"
                       :total="sizeTotal"
                       @size-change="size => $emit('size-change', size)"
                       @current-change="current => $emit('current-change', current)"
                       class="pagination-custom"
                       v-if="showPagination"></pagination-custom>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import PaginationCustom from '@/components/common/PaginationCustom';
import dayjs from 'dayjs';
export default {
  name: 'TableCustom',
  components: {
    PaginationCustom,
  },
  props: {
    colConfigs: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    tableRef: {
      type: String,
      default: 'table-ref'
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    defaultSelection: { // 勾选的行
      type: Array,
      default: () => []
    },
    rowKey: [Function, String],
    treePorps: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Object,
      default: () => {}
    },
    customSort: {
      type: Object,
      default: () => {}
    },
    defaultSort: {
      type: Object,
      default: () => {}
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageNum: { // 前端分页
      type: Number,
      default: 1
    },
    currentPage: { // 后台分页
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    flex: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    headerHighlight: {
      type: Boolean,
      default: true
    },
    border: Boolean,
    tableHeight: String,
    contentStyle: String,
    maxHeight: [String, Number],
    rowClassName: [String, Function],
    cellClassName: [String, Function],
    cellStyle: [Function, Object],
    classNames: String,
    reserveSelection: Boolean,
    summaryMethod: Function,
    showSummary: Boolean,
    summaryText: String,
    spanMethod: Function
  },
  data() {
    return {
      sort: {
        prop: '',
        order: ''
      },
      myFilters: {}
    };
  },
  computed: {
    fmtData() {
      // 过滤
      const filteredData = this.data.filter(
        item => this.filterKeys.every(
          key => {
            if (!this.myFilters[key].length) return true;
            if (isArray(this.myFilters[key])) { // 筛选
              if (this.myFilters[key]) {
                return this.myFilters[key].includes(item[key]);
              }
              return true;
            }
            if (isString(this.myFilters[key])) { // 搜索框
              if (!item[key]) {
                return false;
              }
              if (this.myFilters[key]) {
                return item[key].toLowerCase().includes(this.myFilters[key].toLowerCase());
              }
              return true;
            }
          }
        )
      );
      // 排序
      if (isObject(this.sort)) {
        const { prop, order } = this.sort;
        if (!order || !prop) {
          return filteredData;
        }
        return filteredData.sort((a, b) => {
          if (((a[prop] !== 0 && !a[prop]) || (b[prop] !== 0 && !b[prop]))) {
            return 1;
          }
          if (dayjs(a[prop]).isValid() && dayjs(b[prop]).isValid()) {
            return order === 'ascending' ? dayjs(a[prop]) - dayjs(b[prop]) : dayjs(b[prop]) - dayjs(a[prop]);
          };
          return order === 'ascending' ? a[prop] - b[prop] : b[prop] - a[prop];
        });
      }
      return filteredData;
    },
    tableData() {
      if (!this.showPagination) {
        return this.data;
      } else if (this.pageNum && this.pageSize) {
        return this.fmtData.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
      } else {
        return this.fmtData;
      }
    },
    filterKeys() {
      if (isObject(this.myFilters)) return Object.keys(this.myFilters);
      return [];
    },
    paginationSize: {
      get() {
        return this.pageSize;
      },
      set(value) {
        this.$emit('update:pageSize', value);
      }
    },
    paginationCurrent: {
      get() {
        return this.currentPage || this.pageNum;
      },
      set(value) {
        this.$emit('update:current-page', value);
      }
    },
    sizeTotal() {
      return this.total || this.fmtData.length || 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.toggleSelection(this.defaultSelection);
      this.sort = cloneDeep(this.customSort);
    });
  },
  watch: {
    defaultSelection: {
      handler(value) {
        this.$nextTick(() => {
          this.toggleSelection(this.defaultSelection);
        });
      },
      deep: true,
      setOption: true
    },
    filters: {
      handler(value) {
        this.myFilters = Object.assign({}, this.myFilters, this.filters);
      },
      deep: true
    },
    customSort: {
      handler(value) {
        this.sort = cloneDeep(value);
      },
      deep: true
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        this.data.forEach(row => {
          this.$refs[this.tableRef].toggleRowSelection(row, rows.includes(row));
        });
      } else {
        this.$refs[this.tableRef].clearSelection();
      }
    },
    toggleRowSelection(row, selected) {
      this.$refs['table-ref'].toggleRowSelection(row, selected);
    },
    clearSelection() {
      this.$refs['table-ref'].clearSelection();
    },
    filterChange(filters) {
      this.myFilters = Object.assign({}, this.myFilters, filters, this.filters);
    },
    sortChange({ column, prop, order }) {
      this.sort = { prop, order };
      this.$emit('sort-change', { column, prop, order });
    },
    rowClick(e) {
      this.$emit('row-click', e);
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-table {
  display: flex;
  flex-direction: column;
  // max-height: 100%;
  height: 100%;
  overflow-y: hidden;
  .table-custom {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
    display: flex;
    flex-direction: column;
    /deep/ .el-table__header-wrapper {
      flex-grow: 0;
      flex-shrink: 0;
    }
    /deep/ .el-table__body-wrapper {
      // max-height: 100% !important;
      height: 100%;
      flex-grow: 1;
      flex-shrink: 1;
      overflow-y: auto;
    }
  }
  .empty {
    display: inline-flex;
    flex-direction: column;
    span {
      margin-top: 20px;
      font-size: 18px;
      line-height: 32px;
      color: #464646;
      font-weight: 400;
    }
  }
  .pagination-custom {
    flex-grow: 0;
    flex-shrink: 0;
  }
}
.table-custom {
  /deep/ tr:nth-child(2n) {
    // background-color: $lighten-primary-color;
  }
  /deep/ th.gutter {
    display: table-cell !important;
  }
  /deep/ button {
    padding-top: 0;
    padding-bottom: 0;
  }
  .warning-row {
    background: oldlace;
  }
  .success-row {
    background: #f0f9eb;
  }
  /deep/ .el-table__body-wrapper {
    td.router-btn {
      color: $primary-color;
      cursor: pointer;
    }
  }
  &::before {
    background-color: transparent!important;
  }
  /deep/ .el-table__empty-block {
    width: 100% !important;
    img {
      width: 330px;
    }
  }
  /deep/ .el-table__fixed,
  /deep/ .el-table__fixed-right {
    &::before {
      background-color: transparent!important;
    }
  }
  /deep/ .el-table-column--selection,
  /deep/ .el-table__expand-column {
    .cell {
      padding-left: 0;
      padding-right: 0;
    }
  }
  /deep/ .table-custom-header-cell {
    color: #383839;
    font-weight: 400;
  }
  &.header-highlight {
    /deep/ th {
      height: 52px;
      line-height: 52px;
      background-color: #F5F5FF;
      padding-top: 0px;
      padding-bottom: 0px;
      border-bottom: 0;
    }
    /deep/ tr {
      td {
        border-color: rgba(59, 59, 59, 0.1);
        padding: 20px 0;
      }
      &:last-child {
        td {
          border-bottom-color: transparent;
        }
      }
    }
    &::before {
      background-color: rgba(59, 59, 59, 0.1);
    }
  }
  /deep/ tbody tr:hover {
    &>td {
      background-color: #F7F7FC !important;
    }
  }
  /deep/ .el-table__footer-wrapper {
    tbody {
      td {
        border-color: transparent;
        background-color: #F5F5FF;
      }
    }
  }
  /deep/ .el-table__body-wrapper {
    height: calc(100% - 44px);
    overflow-y: auto;
    // z-index: 2;
  }
  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% - 44px);
    overflow-y: auto;
    // pointer-events: none;
    // cursor: default;
  }
  /deep/ .el-table__fixed {
    height: calc(100% - 12px);
  }
  /deep/ .el-table__fixed-right {
    height: calc(100% - 12px);
  }
  // /deep/ .el-table__footer-wrapper tbody tr:hover {
  //   &>td {
  //     &:nth-last-child(2) {
  //       border-radius: 0 6px 6px 0;
  //     }
  //   }
  // }
  // /deep/ .is-sortable.descending {
  //   .descending {
  //     border-top-color: white!important;
  //   }
  // }
  // /deep/ .is-sortable.ascending {
  //   .ascending {
  //     border-bottom-color: white!important;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TableCustom.vue